import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import tomatologo from '../images/tomoto-logo.png';
import amulya1035 from '../images/tomoto-amulya1035-img.png';
import arudra from '../images/tomoto-arudra-img.png';
import prince from '../images/tomoto-prince-img.png';
import sara from '../images/tomoto-sara-img.png';
const tomatoData = {
  semiDeterminateOval: {
    label: 'Semi Determinate – Oval Shape',
    varieties: [
      {
        name: 'AMULYA-1035',
        image: amulya1035,
        description: [
          'Shows very good stay greenness',
          'Good heat set',
          'Produces attractive firm fruits',
          'Has higher yield potential',
          'Semi-determinate, vigorous plant',
          'Excellent red fruit colour',
          'Fruit weight: 80-100 gm',
          'Average yield: 25-49 MT/acre',
        ],
      },
      {
        name: 'ARUDRA',
        image: arudra,
        description: [
          'High-yielding determinate tomato hybrid developed by Dynasty Agriseeds',
          'Excellent fruit quality and high fruit firmness',
          'Good stay greenness and dark green foliage',
          'Good heat set',
          'Fruit color: Ripe fruits are attractive red and glossy',
          'Fruit shape: Flat round type with uniform green fruits',
          'Fruit weight: 90-100 gm',
          'Average yield: 25-40 MT/acre depending on season and cultural practice',
        ],
      },
      {
        name: 'Prince',
        image: prince,
        description: [
          'Semi determinate open type hybrid',
          'Highly vigorous, profusely flowering, high yielding and oval fruits of around 90 to 100 gm',
          'Tolerance to late blight and TyLCV',
          'Good keeping quality and transportability',
          'Very good for kharif and rabi seasons',
        ],
      },
      {
        name: 'SARA-3501',
        image: sara,
        description: [
          'Produces dark green foliage and stays green for a long duration',
          'Good heat set quality',
          'Produces very good firm fruits',
          'Very high yield potential',
          'Plant type: Determinate',
          'Fruit color: Uniform red and glossy fruit',
          'Fruit shape: Firm and square',
          'Fruit weight: 70-80 g',
          'Average yield: 25-30 MT/acre depending on season and cultural practice',
        ],
      },
     
    ],
  },
  semiDeterminateAcidic: {
    label: 'Semi Determinate – Acidic Type',
    varieties: [
     
    ],
  },
  indeterminateSemiFlat: {
    label: 'Indeterminate – Semi Flat',
    varieties: [
    
    ],
  },
  exoticVarieties: {
    label: 'Exotic Varieties',
    varieties: [
      {
        name: '3/7-T20S-1206RC',
        specs: {
          'PLANT GROWTH HABIT': 'INDETERMINATE',
          'FRUIT SHAPE': 'OVAL',
          'FRUIT SIZE': '7.30cm x 5.30cm',
          'AVERAGE FRUIT WEIGHT': '150-160gm',
          FIRMNESS: 'MODERATELY FIRM',
          'DISEASE RESISTANCE': 'TY2TY3 + BW + I2 + TM2 + VE',
        },
      },
      {
        name: '4/8-T20S-1259',
        specs: {
          'PLANT GROWTH HABIT': 'INDETERMINATE',
          'FRUIT SHAPE': 'SQUARE ROUND',
          'FRUIT SIZE': '7.00cm x 5.80cm',
          'AVERAGE FRUIT WEIGHT': '120-140gm',
          FIRMNESS: 'FIRM',
          'DISEASE RESISTANCE': 'TY2 + BW + I2 + PH3 + VE',
        },
      },
      {
        name: '11/13-T20S-1198RC',
        specs: {
          'PLANT GROWTH HABIT': 'INDETERMINATE',
          'FRUIT SHAPE': 'OBLONG',
          'FRUIT SIZE': '8.40cm x 6.60cm',
          'AVERAGE FRUIT WEIGHT': '160-180gm',
          FIRMNESS: 'MODERATELY FIRM',
          'DISEASE RESISTANCE': 'TY2TY3 + BW + I2 + TM2',
        },
      },
      {
        name: '15/17-T20S-1197RC',
        specs: {
          'PLANT GROWTH HABIT': 'INDETERMINATE',
          'FRUIT SHAPE': 'OVAL/SQUARE ROUND',
          'FRUIT SIZE': '7.50cm x 6.80cm',
          'AVERAGE FRUIT WEIGHT': '180-200gm',
          FIRMNESS: 'MODERATELY FIRM',
          'DISEASE RESISTANCE': 'TY2TY3 + BW + I2 + PH3274',
        },
      },
      {
        name: '90/100-T20S-1204RC',
        specs: {
          'PLANT GROWTH HABIT': 'INDETERMINATE',
          'FRUIT SHAPE': 'OVAL',
          'FRUIT SIZE': '7.20cm x 6.80cm',
          'AVERAGE FRUIT WEIGHT': '150-160gm',
          FIRMNESS: 'MODERATELY FIRM',
          'DISEASE RESISTANCE': 'TY2TY3 + BW + I2 + TM2',
        },
      },
    ],
  },
};

// Flatten all varieties from all categories into a single array
const allVarieties = Object.values(tomatoData).reduce((acc, category) => {
  const imageBackedVarieties = category.varieties.filter((variety) => Boolean(variety.image));
  return [...acc, ...imageBackedVarieties];
}, []);

export default function TomatoPage() {
  return (
    <ProductPatternPage
      title="Tomato"
      varieties={allVarieties}
      pageClass="tomato-page"
      heroImage={tomatologo}
    />
  );
}
